import React from 'react';
import App, { Container } from 'next/app';
import Head from 'next/head';
import Header from '../components/fragments/header';
import Footer from '../components/fragments/footer';
import '../styles/style.scss';

class MyApp extends App {
    static async getInitialProps({ Component, ctx }) {
        let pageProps = {}

        if (Component.getInitialProps) {
            pageProps = await Component.getInitialProps(ctx)
        }
        pageProps.currentUrl = ctx.pathname;   
        return { pageProps }
    }


    render() {

        const { Component, pageProps } = this.props;

        return (
            <Container>
                <Head>
                    <title>PT Jasamarga Tollroad Operator</title>
                </Head>
                <Header activeMenu={pageProps.currentUrl} />
                <div style={{minHeight:"68px"}}></div>
                <Component {...pageProps}  />
                <Footer />
            </Container>
        );
    }
}

export default MyApp;
